// SPDX-FileCopyrightText: 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2022 dv4all
// SPDX-FileCopyrightText: 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export const app = {
  title: 'Research Software Directory',
  unsavedChangesMessage: 'Moving away from editing will discard your changes. This action can not be undone.',
  rsdTokenId: 'rsd_token',
  bprogressHeight: '3px'
}
